module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/twitter.4280456f.svg";